<script lang="ts">

/* 
For dislaying and entry element, that can also be edited when clicked
*/

import type CategoryData from '@/ts/DataTypes/CategoryData';
import Entry from '@/ts/DataTypes/Entry';
import { UserDB } from '@/ts/DexieDB';
import { defineComponent } from 'vue'

import Button from "./Button.vue";
import EntryEditable from './EntryEditable.vue';

export default defineComponent({
    components: { Button, EntryEditable },
    props:
    {
        //have to set to required, or typescript complains it could be undefined, and won't allow you to use it...
        entry:{type:Entry, required:true}, //vue/ typescript doesn't see the entry being passed in as an entry....
        // entry:{type:Object, required:true}, //we are passing it in as an entry, but for some reason vue/ typescript doesn't like it....
        extra_info:Object,
        DeleteEntryClicked:{ type:Function, required:true},
        EntryEditedParent:{ type:Function, required:true},

        //for attributes to be able to confirm being deleted
        ShowModal:{ type:Function, required:true},//have to give it a default value, or typescript thinks it could be undefined...
        EntryOpened:{ type:Function, required:true}, //for when the entry is opened, to let parent know to close others
        // SwitchScreen: { type: Function, required:true },

        BackButtonRegister: { type: Function, required:true },
        MoveForwardToPage: { type: Function, required:true },
        MoveBack: { type: Function, required:true },// switch screen, but just for moving back

        cats:{ type:Array<CategoryData>, required:true},

        GetPrevEntriesForCat:{ type:Function, required:true},
        GetPrevAttributesForCat:{ type:Function, required:true},
        AttributeCreateUpdateOrDelete:{ type:Function, required:true},
        AddOrEditEntry:{ type:Function, required:true},
  },
  data() {
    return {
        editing:false,
        elapsed_time:"",
        elapsed_time_interval:undefined,
        key_to_force_update_on_entry_not_editing:0,

        

        // icon:{ type:String, default:"home"},
        // text:{ type:String, default:"Go Home"}
    }
  },
  mounted()
  {
    this.Mounted();
   
  },
    beforeUnmount()
    {
        console.log("beforeUnmount, destroying interval timer!")
        clearInterval(this.elapsed_time_interval);
    },
    computed: 
    {
        GetCats() 
        {

        },
        

    },
  methods:{

    //for being able to call mounted functions internally from watched: when entry gets updated
    Mounted()
    {
        // console.log("entry mounted with: ", this.entry.item_type, this.entry.date_updated, this.entry.date_finished)
    
        this.ElapsedTime();//fire before the first second/ already mounted

            this.elapsed_time_interval = (setInterval(() => 
            {
                if(!this.entry.date_finished)
                    this.ElapsedTime();
            }, 1000) )as unknown as undefined ;
    },

    ElapsedTime()
    {
        //second example from: https://stackoverflow.com/questions/13903897/javascript-return-number-of-days-hours-minutes-seconds-between-two-dates
        
        // let dateFuture = (this.date_finished as unknown as Date).getTime();
        let dateFuture = new Date().getTime();

        if(this.entry.date_finished)
            dateFuture=this.entry.date_finished.getTime();

        let dateNow = (this.entry.date_updated as unknown as Date).getTime();
        var seconds = Math.floor((dateFuture - (dateNow))/1000);
        var minutes = Math.floor(seconds/60);
        var hours = Math.floor(minutes/60);
        var days = Math.floor(hours/24);

        hours = hours-(days*24);
        minutes = minutes-(days*24*60)-(hours*60);
        seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
        this.elapsed_time = hours + " Hr "+minutes+" Min "+ seconds+" Sec";
        // console.log("elapsed time: ",this.elapsed_time)
        // return elapsed_time;
        //return how much time has passed since time start and end- should grab from task tracker
        // return this.date_finished - this.date_updated.Get;
    },
    
    AddOne()
    {
        // this.count++;
    }, 
    DeleteClicked(extra_info:any)
    {
        extra_info.predelete = this.PreDeleteElement
        this.DeleteEntryClicked(extra_info);
    },
    //for some reason when we remove the entry from the array, vue puts the editing flag onto the next rendered element... so need to reset this vue element, because it applies the data to the next rendered element for some reason...
    PreDeleteElement()
    {
        console.log("pre delete element called!")
        // this.ScrollToTopOfElement();
        // this.editing=false;
        this.Close();
    },
    EditSubmitted(extra_info:any)
    {
        console.log("EditSubmitted!", extra_info);
        // extra_info.entry.name=(this.$refs.text as HTMLInputElement).value;
        // console.log("EditSubmitted!", this.$refs.text);
        this.EntryEditedParent(extra_info);
        // this.editing=false;
        // this.Close();
        //should edit the name of the entry, and let the parent know to update the UI
    },
    EntryClicked()
    {
        this.EntryOpened(this);

        this.editing=true;
        console.log("entry clicked!");
        //should make it editable/ change it out with input box to edit name

        //should also let the parent know, to change any being edited to no longer being edited
        //so let parent know so they can close existings entrys open, and set this one to open
        
    },
    ScrollToTopOfElement()
    {
        //scroll back to the top of this entry
        //also needs to be called when deleting the element (which gets called in predelete/ final deletion)
        /* let top = (this.$refs.main_entry as HTMLElement).getBoundingClientRect().top+ window.scrollY;
        console.log("EntryEl close fired, scrolling! to: ", top);
        document.getElementById("scroller")!.scrollTo({
        top: top,
        behavior: 'smooth',
        }) */
        // (this.$refs.main_entry as HTMLElement).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        let scroll_container = (document.getElementById("scroller") as HTMLElement);
        let yOffset = -50;
        const y = (this.$refs.main_entry as HTMLElement).getBoundingClientRect().top + scroll_container.scrollTop + yOffset;
        scroll_container.scrollTo({
        top: y,
        behavior: 'smooth',
        })
    },
    /**
     * 
     * @param scroll_to_element only if wantingto scroll to the top of this element- false for closing elements already open
     */
    Close(scroll_to_element:boolean=true)
    {
        this.editing=false;

        if(scroll_to_element)
        {
            this.ScrollToTopOfElement();

            let bg = (this.$refs.bg as HTMLElement);
            bg.style.animation="highlight_entry 1.5s";
            bg.addEventListener("animationend", function() {
                if(bg)
                    // bg.classList.remove("highlight_entry");
                    bg.style.animation="";
            });
        }
        

        //it fires the click/ open command after the close function is hit- so have to wait till next tick to close it
        // this.$nextTick(() => 
        // {
        //     console.log("going to set editing to false! closing");
        //     // this.editing=false;
        // //   component_this[array_name] = [...arr_temp];
        // });
    },
    UpdateCatsAfterAddOrUpdate()
    {
        console.log("EntryEl: Got UpdateCatsAfterAddOrUpdate");
    },
    GetTimeElapsed()
    {
        console.log("EntryEl: Got UpdateCatsAfterAddOrUpdate");
    },
    async EndTask()
    {
        this.entry.date_finished = new Date();
        this.key_to_force_update_on_entry_not_editing++;

        console.log("date finished changed to: ", this.entry.date_finished, "date_updated: ", this.entry.date_updated)

        //doesn't seem to update the UI consistantly...

        //doesn't update the UI when the status on entry is changed- unless we console.log out...
        // this.ForceUpdate();
        // console.log("End task called! date finished: ", this.entry.date_finished, "and tracking: ", this.entry.tracking)
        //also end it on the server/ submit changes to the server
        await this.AddOrEditEntry([this.entry]);
    },
    // ForceUpdate()
    // {
    //     this.key++;
    // },

  },
  watch : {
        // date_finished:function(date_in) 
        // {
        //     console.log("watch date_finished  called");
        //     console.log("entry watch with: ", this.entry.item_type, this.entry.date_updated, this.entry.date_finished)
        //         //   this.date_s = this.ChangeDateToRequiredStringFormat(date_in);
        // },
        // date_updated:function(date_in)
        // {
        //     console.log("watch date_updated  called");
        //     console.log("entry watch with: ", this.entry.item_type, this.entry.date_updated, this.entry.date_finished)
        //         //   this.date_s = this.ChangeDateToRequiredStringFormat(date_in);
        // }
        // ,
        entry:function(date_in) 
        {
            // console.log("watch entry  called");
            // console.log("entry watch with: ", this.entry.item_type, this.entry.date_updated, this.entry.date_finished)
                //   this.date_s = this.ChangeDateToRequiredStringFormat(date_in);

                //so we do get the updated date here- so can use that to re-run things done in mounted- mainly time elapsed
                this.Mounted();
        }
    },
  
  

})
</script>

<template>
    <div  class="entry" @click="()=>{EntryClicked()}"  :key="key_to_force_update_on_entry_not_editing" ref="main_entry">
    <div class="bg" ref="bg"></div>

    <div class="not_bg">
    <div v-if="!editing" class="not_editing">
        <!-- {{entry}} -->
		 <!-- 2026-06-26 - changing out to allow multi lines -->
        <!-- <span style="color:white;">{{ entry.item_type }}</span> -->
		<p style="color:white;" :innerText=entry.item_type ></p>

        <!-- {{ "&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;"+entry.date_updated.toLocaleDateString() +" -- "+entry.date_updated.toLocaleTimeString()}} -->
        <!-- {{ "&nbsp;&nbsp;&nbsp;&nbsp;||&nbsp;&nbsp;&nbsp;&nbsp;"+entry.date_updated.toLocaleTimeString()}} -->
        {{ "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+entry.date_updated.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}

        <span v-if="entry.date_finished">
            <span>---->{{ ""+entry.date_finished.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}</span>
            <p class="elapsed_time">{{ " Elapsed: "+elapsed_time}}</p>
        </span>

        <div v-if="entry.tracking&&!entry.date_finished">
            <p class="elapsed_time">{{ " Elapsed: "+elapsed_time}}</p>
            <Button 
            class="btn_end_task"  :callback="()=>{EndTask();}" 
                text="End Task"  color_bg="hsl(15, 80%, 50%)" color_bg2="hsl(0, 60%, 30%)" 
                color_txt="var(--greyF)" fontsize="16px"/>
        </div>
        <!-- {{entry.date_updated}} -->
            
        <!-- SHould also have a list of attributes-->
        <div style="padding-left:40px;">
            <p v-for="attr in entry.attributes">
                {{ attr.name }}: {{attr.value}}<span v-if="attr.rating!='-1'">; rating:  {{ attr.rating }}</span>
            </p>
        </div>

    </div>
    <div v-else class="entry_editable">
        <EntryEditable  :extra_info="extra_info"

        :entry="entry"
        :DeleteEntryClicked="DeleteClicked"
        :AddOrEditEntry="EditSubmitted"

        
        
        :BackButtonRegister="BackButtonRegister"
        :MoveForwardToPage="MoveForwardToPage"
        

        :MoveBack="Close"
        :is_new_screen="false"
        
        :ShowModal="ShowModal"
        :cats="cats"
        :GetPrevEntriesForCat="GetPrevEntriesForCat"
        :GetPrevAttributesForCat="GetPrevAttributesForCat"
        :AttributeCreateUpdateOrDelete="AttributeCreateUpdateOrDelete"

        
         />

        <!-- <input type="text" :value="entry.item_type" ref="text" @keyup.enter="()=>{EditSubmitted(extra_info)}"/>
        <Button type="yes" :callback="EditSubmitted" :extra_info="extra_info" />
        <Button type="delete" :callback="DeleteClicked" :extra_info="extra_info" bg_color="red" />
        <Button type="no" :callback="()=>{editing=false;}"  bg_color="#DDD" txt_color="#333"/> -->
    </div>
</div>


</div>
</template>


<style scoped>
* {
    font-size:18px;
}
.entry
{
    
    padding:10px 20px;
    position: relative;
    cursor: pointer;
    user-select: none;
    
}
/* .not_editing
{
    pointer-events: none; 
} */
.bg
{
    background-color:#333;

    animation-fill-mode: forwards;

    /* animation: highlight 2s linear infinite; */

    /* animation-name: highlight;
    animation-duration: 2s; */
    
    
    width:100%;
    height:100%;
    position: absolute;
    top:0;
    left:0;
    pointer-events: auto; 
    transition: .25s all;
}
/*
to make it so that backgrounds are above the background- otherwise for some reason they get rendered behind it, even when they are on top of it, except when hovered
*/
.not_bg
{
    z-index: 1;
}
.entry:hover .bg
{
    /* filter: brightness(1.25); */
    background-color:rgb(52, 85, 48);
}


.elapsed_time
{
    font-weight: bold;
    color:white;
}
.btn_end_task
{
    width:100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom:0px;
    max-width:400px;
    display:block;
}
/* .entry_editable
{
    display:flex;
    justify-content: stretch;
    gap: 10px;
}
.entry_editable *
{
    min-width:.5in;
    min-height:.5in;
}
.entry_editable input[type="text"]
{
    flex-basis: 80%;
}
.entry_editable button
{
    margin:0;
    aspect-ratio: 1;
} */
</style>
<style>
@keyframes highlight_entry {
  0%   {background-color: rgb(52, 85, 48);}
  50%  {background-color: green;}
  100% {background-color: #333;}
}

</style>